// AI Generated Test
import { Component, Input, inject, OnInit } from '@angular/core';
import { SeoRepoService } from '@client/app/services/api/seo-repo/seo-repo.service';
import { CheckForDuplicatesService } from '@client/app/core/services/check-for-duplicates/check-for-duplicates.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-seo-pages-dialog',
    standalone: false,
    template: `
        <div class="mon-dialog-header">
            <page-header header="{{ 'Pages' | translate }}"
                         subHeader="{{ 'Total pages: ' | translate }} {{ pages.total | monNumber }}">
            </page-header>
        </div>

        <div class="mon-dialog-body">
            <div class="card panel-monsido-card mt-3 mx-3">
                <div class="card-body">
                    <table-container [progress]="progress"
                                     [collection]="pages"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     noResultMessage="{{ 'Good job! No issues were found' | translate }}">
                        <table class="table table-hover table-fixed">
                            <thead>
                            <tr>
                                <th class="col-sm-20 col-md-20 col-lg-20"><span class="inner-l-small" translate>Title</span></th>
                                <th *ngIf="viewsColumIsAvailable" class="col-sm-3 col-md-4 col-lg-4"><span class="inner-r-small" translate>Views</span></th>
                                <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td class="text-ellipsis">
                                    <div class="inner-l-small text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable"
                                                [target]="'page-details-section-seo'"
                                                [subTarget]="seo"
                                                [page]="page"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </url-title-page-details>
                                    </div>
                                </td>
                                <td *ngIf="viewsColumIsAvailable" class="text-v-middle">
                                    <visits [visits]="page.hits" [title]="page.title" [totalVisits]="pages.pageHits"></visits>
                                </td>
                                <td class="text-right text-v-middle" [attr.aria-label]="'Page details' | translate">
                                    <div class="pl-2">
                                        <table-page-details [target]="'page-details-section-seo'"
                                                            [subTarget]="seo"
                                                            class="list-inline inline-block"
                                                            [page]="page">
                                        </table-page-details>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSeoPagesPagesDialogComponent extends BaseContainerComponentController implements OnInit {
    @Input() seo: any;
    @Input() title?: any;

    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    override search: string = '';
    override page: number = 1;
    override pageSize: number = 10;
    tabs: any[] = [];
    pages: any = [];
    progress: any;

    private seoRepoService = inject(SeoRepoService);
    private checkForDuplicatesService = inject(CheckForDuplicatesService);
    private activeFeatureService = inject(ActiveFeatureService);

    constructor () {
        super({ table: true });
    }

    ngOnInit (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.search = '';
        this.tabs = [];
        this.pages = [];
        this.getPage();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            content: this.seo.content,
            page_size: this.pageSize,
            title: this.title || null,
        };

        this.seoRepoService.getSeoIssuePages(this.seo.id, params).then((data) => {
            this.checkForDuplicatesService.checkForDuplicatePages(data as any);
            this.pages = data;
        }, () => {});
    };
}
